import { ResponseType } from 'axios';

// Endpoint はsecrets で取ってくるようにしたほうがいい気がしたけど要検討 -> 実現できる？セキュリティ的にはどう？ -> 全然考えてない
export const TOPCONECT = {
  ENDPOINT: {
    DEV: 'https://jx83vmqdy3.execute-api.ap-northeast-1.amazonaws.com/dev',
    QA: 'https://78szzwodlf.execute-api.ap-northeast-1.amazonaws.com/qa',
    PROD: 'https://e9qalgx5mf.execute-api.ap-northeast-1.amazonaws.com/prod',
  },
};

export const TOPCONECT_MANAGEMENT = {
  ENDPOINT: {
    DEV: 'https://x2flgzqnu0.execute-api.ap-northeast-1.amazonaws.com/dev',
    QA: 'https://zderqvbwcc.execute-api.ap-northeast-1.amazonaws.com/qa',
    PROD: 'https://gttktlm2ch.execute-api.ap-northeast-1.amazonaws.com/prod',
  },
};

export const KEY = {
  DEV: 'PqcC8J9uXd2TPDOZjaGBSDXQS49URNj7lXzPpUdj',
  QA: '3cAWla27lK1GbkWD6aM501YWvfg5sdoF8boBZuJA',
  PROD: 'E7Mme2GMFD3uPCJ8j1ed01X7bvhOrhuBa53N9kdo',
};

export const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
} as const;

export const RESPONSE_TYPE: ResponseType = 'json';
